module.exports = __webpack_public_path__ + "img/icon_not_support.c329536b.svg";